import { render, staticRenderFns } from "./CustomerLanguage.vue?vue&type=template&id=24e02e4a&"
import script from "./CustomerLanguage.vue?vue&type=script&lang=ts&"
export * from "./CustomerLanguage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports